import React from 'react';
import { Link } from 'react-router-dom';
import { FiTerminal } from 'react-icons/fi';
import { SiClaude, SiGithubcopilot, SiGooglegemini, SiOpenai, SiWarp, SiZedindustries } from 'react-icons/si';
import { VscVscode } from 'react-icons/vsc';

const connections = [
    {
        name: 'ChatGPT',
        path: '/chatgpt',
        Icon: SiOpenai,
        iconColor: '#171717'
    },
    {
        name: 'Claude',
        path: '/claude',
        Icon: SiClaude,
        iconColor: '#d97757'
    },
    {
        name: 'Codex',
        Icon: FiTerminal,
        iconColor: '#171717'
    },
    {
        name: 'Gemini',
        Icon: SiGooglegemini,
        iconColor: '#4285f4'
    },
    {
        name: 'GitHub Copilot',
        Icon: SiGithubcopilot,
        iconColor: '#181717'
    },
    {
        name: 'Zed',
        Icon: SiZedindustries,
        iconColor: '#084ccf'
    },
    {
        name: 'Visual Studio Code',
        Icon: VscVscode,
        iconColor: '#007acc'
    },
    {
        name: 'Warp',
        Icon: SiWarp,
        iconColor: '#171717'
    },
    {
        name: 'Antigravity',
        iconSrc: 'https://framerusercontent.com/images/OqB3G5Li69i4DK7tetSlKF7S0U.png?width=256&height=256'
    },
    {
        name: 'LM Studio',
        iconSrc: 'https://framerusercontent.com/images/zHpiwPJOCiVCnDJvFK6lTXtZQg8.png?width=256&height=256'
    }
];

const McpConnections = () => (
    <section className="landing-section mcp-connections" aria-labelledby="mcp-connections-title">
        <div className="container">
            <div className="mcp-connections-inner">
                <div className="mcp-connections-intro">
                    <h2 id="mcp-connections-title">Works with the AI you already use.</h2>
                    <p>
                        Connect Luckynote through MCP, so your saved context is ready wherever you work.
                    </p>
                </div>
                <div className="mcp-connections-cards">
                    {connections.map(({ Icon, iconColor, iconSrc, ...connection }) => {
                        const content = iconSrc
                            ? <img className="mcp-connection-image" src={iconSrc} alt="" />
                            : <Icon aria-hidden="true" />;

                        return connection.path ? (
                            <Link
                                key={connection.name}
                                to={connection.path}
                                className="mcp-connection-mark"
                                style={{ color: iconColor }}
                                aria-label={`Connect Luckynote to ${connection.name}`}
                            >
                                {content}
                            </Link>
                        ) : (
                            <span
                                key={connection.name}
                                className="mcp-connection-mark"
                                style={{ color: iconColor }}
                                role="img"
                                aria-label={connection.name}
                            >
                                {content}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    </section>
);

export default McpConnections;
